import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import clsx from 'clsx';

import useStyles from './OptionsList.styles';

const SelectOptionsList = ({
  options, onSelect, alignToLeft, isMultiSelect, isAll, allLabel,
}) => {
  const classes = useStyles();

  return (
    <ul className={clsx(classes.container, {
      [classes.alignToLeft]: alignToLeft,
    })}
    >
      <li
        className={classes.item}
        onClick={() => onSelect('all')}
      >
        {isMultiSelect && <Checkbox color="primary" checked={isAll} />}
        {!isMultiSelect && <Radio color="primary" checked={isAll} />}
        {allLabel}
      </li>
      {options.map(({ id, title, isSelected }) => (
        <li
          key={id}
          className={classes.item}
          onClick={() => onSelect(id)}
        >
          {isMultiSelect && <Checkbox color="primary" checked={isSelected} />}
          {!isMultiSelect && <Radio color="primary" checked={isSelected} />}
          {title}
        </li>
      ))}
    </ul>
  );
};

SelectOptionsList.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
  })).isRequired,
  onSelect: PropTypes.func,
  alignToLeft: PropTypes.bool,
  isMultiSelect: PropTypes.bool,
  isAll: PropTypes.bool,
  allLabel: PropTypes.string,
};
SelectOptionsList.defaultProps = {
  onSelect: () => {},
  alignToLeft: false,
  isMultiSelect: false,
  isAll: false,
  allLabel: 'All',
};

export default SelectOptionsList;
